import { forwardRef, useEffect } from 'react';
import { createPortal } from 'react-dom';

// Every modal overlay renders through here so it escapes the page's stacking
// context. `.main-content > *` carries `position: relative; z-index: 1`, which
// trapped inline overlays UNDER the phone tab bar (z 100) and top bar (z 101)
// no matter how high their own z-index was — that is why drivers could not
// reach the submit button at the bottom of Resolve Call. Portaling to <body>
// puts the overlay in the root stacking context where its z-index means what
// it says. While any overlay is mounted, body.modal-open hides the tab bar and
// the pinned page action and locks page scroll, so the sheet owns the screen.
let openCount = 0;
let savedOverflow = '';

const ModalRoot = forwardRef(function ModalRoot({ className = 'modal-overlay', children, ...rest }, ref) {
  useEffect(() => {
    if (openCount === 0) {
      savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    openCount += 1;
    document.body.classList.add('modal-open');
    return () => {
      openCount = Math.max(0, openCount - 1);
      if (openCount === 0) {
        document.body.style.overflow = savedOverflow;
        document.body.classList.remove('modal-open');
      }
    };
  }, []);
  return createPortal(<div ref={ref} className={className} {...rest}>{children}</div>, document.body);
});

export default ModalRoot;
